<template>
  <div>
    <b-col
      cols="12"
      class="mb-24"
    >
      <datatable
        :items="dataItems"
        :fields="fields"
      >
        <template #filters>
          <b-col
            cols="12"
            md="3"
            sm="12"
          >
            <b-form-select
              id="sectionType"
              v-model="selectedSection"
              :options="wrappedSections"
              value-field="id"
              text-field="name"
              class="my-3"
              placeholder="Selecciona datos una Sección"
              @change="filterBySection"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            sm="12"
          >
            <multiselect 
              id="sectionType" 
              v-model="valuesOptions" 
              :options="options" 
              :multiple="true"  
              placeholder="Filtrar datos por proyecto" 
              label="name" 
              track-by="id"
              :preselect-first="true"
              :close-on-select="false" 
              :clear-on-select="false" 
              :preserve-search="true"
              class="my-3" 
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} Proyectos</span></template>
            </multiselect>
          </b-col>
          <b-col
            cols="12"
            md="3"
            sm="12"
            class="text-left"
          >
            <b-button 
              class="my-3 me-auto" 
              variant="outline-primary" 
              @click="onSearchFilter"
              :disabled="valuesOptions.length === 0 || !selectedSection"
            >
              Filtrar
            </b-button>  
          </b-col>
        </template>
        <template #checklist_type_show_code="{ item }">
          <span>
            {{
              item.place.name
            }}
          </span>
        </template>
        <template #checklist_type_show="{ item }">
          <span>
            {{
              item.checklist.checklist_type
                ? item.checklist.checklist_type.name
                : "Sin tipo"
            }}
          </span>
        </template>
        <template #status="{ item }">
          <div class="d-flex align-items-center justify-content-center">
            <b-badge
              :id="`${item.checklist.id}-approved-answers`"
              variant="primary"
            >
              {{ item.checklist.status.approved_percent }}%
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-approved-answers`"
              >Porcentaje de respuestas aprobadas</b-tooltip
            >
            <b-badge
              :id="`${item.checklist.id}-pending-answers`"
              variant="info"
              class="mx-2"
            >
              {{ item.checklist.status.pending_percent }}%
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-pending-answers`"
              >Porcentaje de respuestas pendientes de aprobar</b-tooltip
            >
          </div>
        </template>
        <template #questions="{ item }">
          <div class="d-flex justify-content-start">
            <b-progress
              :value="item.checklist.status_completed"
              :max="100"
              class="w-75 mr-2"
              variant="warning"
            >
              <b-progress-bar :value="item.checklist.status_completed">
              </b-progress-bar>
            </b-progress>
            <small> {{ item.checklist.status_completed }}% </small>
          </div>
        </template>
        <template #rejected="{ item }">
          <div class="d-flex align-items-center justify-content-center">
            <b-badge
              class="pointer"
              :id="`${item.checklist.id}-rejected-answers`"
              @click="goToRejected(item)"
              variant="danger"
            >
              {{ item.checklist.status.rejected_total }}
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-rejected-answers`"
              >Cantidad de respuestas rechazadas</b-tooltip
            >
          </div>
        </template>
        <template #pending_replacement="{ item }">
          <div class="d-flex align-items-center justify-content-center">
            <b-badge
              :id="`${item.checklist.id}-pending-replacement-answers-percent`"
              variant="primary"
            >
              {{ item.checklist.status.pending_replacement_percent }}%
            </b-badge>
            <b-tooltip
              :target="`${item.checklist.id}-pending-replacement-answers-percent`"
              >Porcentaje de respuestas pendientes de sustitución</b-tooltip
            >
            <b-badge
              :id="`${item.checklist.id}-pending-replacement-answers`"
              variant="info"
              class="mx-2"
            >
              {{ item.checklist.status.pending_replacement }}
            </b-badge>
            <b-tooltip
              :target="`${item.checklist.id}-pending-replacement-answers`"
              >Cantidad de respuestas pendientes de sustitución</b-tooltip
            >
          </div>
        </template>
        <template #replaced="{ item }">
          <div class="d-flex align-items-center justify-content-center">
            <b-badge
              :id="`${item.checklist.id}-replaced-answers-percent`"
              variant="primary"
            >
              {{ item.checklist.status.replaced_percent }}%
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-replaced-answers-percent`"
              >Porcentaje de respuestas sustituidas</b-tooltip
            >
            <b-badge
              :id="`${item.checklist.id}-replaced-answers`"
              variant="info"
              class="mx-2"
            >
              {{ item.checklist.status.replaced }}
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-replaced-answers`"
              >Cantidad de respuestas sustituidas</b-tooltip
            >
          </div>
        </template>
      </datatable>
      <!-- <div
        v-else
        class="text-center"
      >
        <h5 class="mb-0">
          <b-spinner class="align-middle mr-8" />
        </h5>
      </div> -->
    </b-col>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BCol } from 'bootstrap-vue'
import Multiselect from 'vue-multiselect'
import Datatable from '@/view/components/common/datatable/Datatable.vue'
import moment from 'moment'

export default {
  components: {
    // BSpinner,
    BCol,
    Datatable,
    Multiselect
  },
  props: {
    list: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      selectedSection: null,
      textFilterSection: 'Filtrar datos por Sección',
      options: [],
      valuesOptions: [],
      filteredItems: [],
      dataItems: [],
      items: [],
      fields: [
        {
          key: "place.code",
          label: "Nombre proyecto",
          sortable: true,
          class: "text-center px-1",
        },
        {
          key: "checklist.name",
          label: "Nombre",
          sortable: true,
          class: "text-center px-1",
        },
        {
          key: "questions",
          label: "Preguntas",
          sortable: false,
          class: "px-3",
        },
        {
          key: "status",
          label: "Respuestas",
          sortable: false,
          class: "text-center px-2",
        },
        {
          key: "rejected",
          label: "Rechazadas",
          sortable: false,
          class: "text-center px-1",
        },
        {
          key: "pending_replacement",
          label: "Pendientes de sustitución",
          sortable: false,
          class: "text-center pl-2",
        },
        {
          key: "replaced",
          label: "Sustituidas",
          sortable: false,
          class: "text-center px-1",
        },
      ],
    }
  },
  async mounted() {
    await this.getProjectsData();
  },
  methods: {
    ...mapActions({
      getProjects: "project/getProjects",
      getProjectsPaginated: "project/getProjectsPaginated",
      getBatchPlace: "place/getBatchPlace"
    }),
    async getProjectsData(){
      this.loading = true
      const dataProjects = await this.getProjects()
      this.options = dataProjects;
      setTimeout(() => {
        this.loading = false
      }, 300)
    },
    resolveSectionName(id) {
      const { name } = this.sections.find(e => e.id === id)
      return name
    },
    setDataGraphs(data) {
      this.loading = true
      this.items = []
      Object.entries(data).forEach(([key, value]) => {
        value.secciones.forEach(seccion => {
          Object.entries(seccion.checklist_places).forEach(checklistPlace => {
            this.items.push({
              date: `${moment(checklistPlace[1].answer[0].created_at).format('DD/MM/YYYY HH:mm')} hrs`,
              template_name: checklistPlace[1].name,
              place: checklistPlace[1].answer[0].place.name || '',
              section: checklistPlace[1].section,
              section_name: this.resolveSectionName(checklistPlace[1].section),
            })
          })
        })
      })
      this.filterBySection(this.selectedSection)
      setTimeout(() => {
        this.loading = false
      }, 300)
    },
    filterBySection(id) {
      console.log({ projects: this.projects })
      if (id !== null) {
        this.filteredItems = this.items.filter(e => e.section === id)
      } else {
        this.filteredItems = this.items
      }
    },
    async onSearchFilter(){
      let idsProjects = [];

      this.valuesOptions.map((item) => {
        idsProjects.push(item.id);
      })

      console.log({ projectsSelected: this.valuesOptions, selectedSection: this.selectedSection })

      const dataLisTable = await this.getBatchPlace({
        projects: idsProjects.join(','),
        section: this.selectedSection 
      });

      if( dataLisTable.length > 0 ){
        let items = [];
        dataLisTable.map((item) => {
          const checkPlace = item.checkl_places;
          for (const key in checkPlace) {
            if ( Array.isArray(checkPlace[key]) && checkPlace[key].length > 0 ) {
              items = [ ...items,  ...checkPlace[key] ];
            }
          }
        })

        this.dataItems = items;
      }

      console.log({ dataLisTable })
    }
  },
  computed: {
    ...mapGetters({
      graphs: 'dashboard/graphs',
      sections: 'project/sections',
      projects: "project/projects",
    }),
    wrappedSections() {
      return [
        { id: null, name: this.textFilterSection, disabled: true },
        ...this.sections,
      ]
    },
  },
  watch: {
    sections: {
      handler(newValue) {
        this.selectedSection = newValue[0].id
        this.filterBySection(this.selectedSection)
      },
      deep: true,
    },
    graphs: {
      handler(newValue) {
        this.setDataGraphs(newValue)
      },
      deep: true,
    },
  },
}
</script>
